import styled from 'styled-components'

export const StyledCoursesContainer = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  align-items: center;
  padding: 1rem 4vw;

  @media only screen and (max-width: 600px) {
    padding: 0;
  }
`
